import React, { useEffect, useState } from 'react';
import { useSnackbar } from 'notistack';
import { useTranslation } from 'react-i18next';
import Modal from '../../../../components/Modal';
import LoadingState from '../../../../components/LoadingState';
import useOrders from '../../../../hooks/useOrders';
import FormSelect from '../../../../components/FormSelect';

interface Props {
  open: boolean;
  onClose: () => void;
  orderId: string;
  handleSetStatus: (
    table_id: string,
    status_id: number,
    isPickedUp?: boolean,
  ) => void;
  statusId?: number;
  setAddCourierModal?: (
    value: ((prevState: boolean) => boolean) | boolean,
  ) => void;
  activeDelivererId?: string; // Add this line
}

function OrderRejectModal({
  open,
  onClose,
  orderId,
  handleSetStatus,
  statusId,
  setAddCourierModal,
  activeDelivererId, // Add this line
}: Props) {
  const { t } = useTranslation('orders');
  const { enqueueSnackbar } = useSnackbar();
  const { getCancelReasons, useRejectOrder } = useOrders();

  const [cancelReasons, setCancelReasons] = useState<
    { id: string; description: string }[]
  >([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [rejectReasonId, setRejectReasonId] = useState<string>('');

  useEffect(() => {
    const fetchCancelReasons = async () => {
      try {
        const reasons = await getCancelReasons(orderId);
        if (reasons.data && reasons.data.length > 0) {
          setCancelReasons(reasons.data);
        } else {
          console.log('No cancel reasons found');
        }
      } catch (err) {
        enqueueSnackbar('Error fetching cancel reasons', { variant: 'error' });
      } finally {
        setLoading(false);
      }
    };

    if (open) {
      fetchCancelReasons();
    }
  }, [open]);

  const handleRejectOrder = async () => {
    try {
      await useRejectOrder(orderId, rejectReasonId);
      enqueueSnackbar('Sipariş İptal Edildi.', { variant: 'success' });
      onClose();
    } catch (err) {
      enqueueSnackbar('Error rejecting order', { variant: 'error' });
    }
  };

  return (
    <Modal
      maxWidth="md"
      open={open}
      onClose={onClose}
      title="Task İptali"
      positiveAction="Reddet"
      negativeAction={t('order.deliverer_modal.close')}
      onPositiveClick={handleRejectOrder}
    >
      {loading ? (
        <LoadingState />
      ) : (
        <FormSelect
          label="İptal Nedenleri"
          value={rejectReasonId}
          onChange={(e: any) => setRejectReasonId(e.target.value)}
          options={cancelReasons?.map(reason => ({
            id: reason?.id,
            text: reason?.description,
          }))}
        />
      )}
    </Modal>
  );
}

export default OrderRejectModal;
